import { render, staticRenderFns } from "./ProjectDetailsCopy.vue?vue&type=template&id=2f4846a1&scoped=true&"
import script from "./ProjectDetailsCopy.vue?vue&type=script&lang=js&"
export * from "./ProjectDetailsCopy.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDetailsCopy.vue?vue&type=style&index=0&id=2f4846a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4846a1",
  null
  
)

export default component.exports